import { useState } from "react";
import "./index.css";

type Section = {
  title: string;
  questions: string[];
};

const sections: Section[] = [
  {
    title: "Для партнёра в отношениях ❤️",
    questions: [
      "Как пахло место, где вы впервые встретились?",
      "Какой аромат напоминает о первых поцелуях?",
      "Если бы ваши отношения были ароматом — он был бы больше тёплый, сладкий или свежий?",
      "Какой запах ассоциируется с уютными моментами вместе (кофе, выпечка, плед)?",
      "Есть ли у него/неё запах, который сразу всплывает в памяти (духи, шампунь)?",
    ],
  },
  {
    title: "Для хорошего друга 🤝",
    questions: [
      "Как пахнет ваше самое яркое воспоминание вместе (костёр, кинотеатр, спортзал)?",
      "Если бы ваш друг был ароматом — это больше свежий, энергичный или спокойный запах?",
      "Какой запах вы чаще всего ощущали рядом с ним/ней?",
      "Какой запах описывает ваши приключения вместе (бензин дороги, море, лес)?",
      "Есть ли аромат, который символизирует атмосферу вашего общения?",
    ],
  },
  {
    title: "Для родителей 👨‍👩‍👧",
    questions: [
      "Как пахнет дом, в который вы возвращаетесь?",
      "Какой запах всегда был рядом с мамой или папой?",
      "С каким запахом у вас ассоциируются праздники дома?",
      "Какой запах вызывает чувство защищённости?",
      "Как пахнет момент, когда они вас обнимают?",
    ],
  },
  {
    title: "Символичный подарок 🎁",
    questions: [
      "Какой запах передаёт событие, ради которого вы дарите подарок?",
      "Если бы это был сезон — какой запах этого времени?",
      "Какой запах вызывает у вас чувство начала чего-то нового?",
      "Если бы этот подарок был песней, какой запах у неё был бы?",
      "Какой запах вы хотите, чтобы человек запомнил именно с этим подарком?",
    ],
  },
];

export default function AssosiationHelper() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="hints">
      <h2 className="hints__title">Затрудняетесь ответить?</h2>
      <p className="hints__subtitle">
        Старайтесь указывать ассоциации через запахи и чувства. Эти вопросы
        помогут вам вспомнить важные моменты.
      </p>

      <div className="hints__list">
        {sections.map((sec, i) => (
          <div key={i} className="accordion">
            <button
              className="accordion__header"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              aria-expanded={openIndex === i}
            >
              <span>{sec.title}</span>
              <span className={`chev ${openIndex === i ? "chev--up" : ""}`} />
            </button>
            {openIndex === i && (
              <div className="accordion__body">
                <ul>
                  {sec.questions.map((q, j) => (
                    <li key={j}>{q}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
